export default "__VITE_ASSET__cbc4ecb2__"